import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
  isActive?: boolean;
  onClick?: () => void;
}

export default function CategoryCard({ slug, name, icon, description, count, isActive, onClick }: CategoryCardProps) {
  const content = (
    <div
      className={`group cursor-pointer p-5 rounded-lg border transition-all duration-300 ${
        isActive
          ? 'bg-primary-50 border-primary-300'
          : 'bg-background-50 border-background-200/70 hover:border-primary-200 hover:bg-background-100'
      }`}
      onClick={onClick}
    >
      <div className={`w-10 h-10 flex items-center justify-center rounded-lg mb-3 transition-colors ${
        isActive ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-700 group-hover:bg-primary-500 group-hover:text-background-50'
      }`}>
        <i className={`${icon} text-lg`}></i>
      </div>
      <h3 className={`font-heading text-sm mb-1 transition-colors ${
        isActive ? 'text-primary-700' : 'text-foreground-900'
      }`}>
        {name}
      </h3>
      <p className="text-xs text-foreground-500 mb-2 line-clamp-1">{description}</p>
      <span className={`text-xs font-medium ${
        isActive ? 'text-primary-500' : 'text-foreground-400'
      }`}>
        {count} 个视频
      </span>
    </div>
  );

  if (slug === 'all') {
    return (
      <Link to="/category/all" className="block">
        {content}
      </Link>
    );
  }

  return content;
}